import { ImportContent } from './ui/import-content/import-content'
import { ImportHeader } from './ui/import-header'

export const ImportPage = () => {
  return (
    <div className="px-10 py-11">
      <ImportHeader />
      <ImportContent />
    </div>
  )
}
